<template>
  <div id="loto-game" class="game">
    <router-link to="/" tag="div" class="close">×</router-link>
    <h1>Bingo</h1>
    <form class="game-wrapper layout-1" @submit="start">
      <div class="layout-content">
        <ul id="balls" v-if="order">
          <li v-for="(value, key) in order.slice(0, current)" v-bind:key="key" class="ball" :data-n="value % 6"><span :style="{transform: get_rotation(key, value)}">{{ value }}</span></li>
        </ul>
      </div>
      <div class="layout-navigation" v-if="started">
        <button v-if="current < max" class="action-button reset-button" type="button" @click="again">Stop</button>
        <button v-else class="action-button" type="button" @click="again">Play again</button>
        <button v-if="current < max" class="action-button" type="button" @click="next_number">Next</button>
      </div>
      <div class="layout-navigation" v-else>
        <span style="padding-left: 2rem;">Max:</span>
        <input type="number" min="1" max="99" v-model="max" maxlength="2" />
        <button class="action-button">Start</button>
      </div>
    </form>
  </div>
</template>

<script>

import Random from './../utils/random'

export default {
  data: function () {
    return {
      'order': null,
      'max': 75,
      'current': 0,
      'started': false
    }
  },
  beforeDestroy: function() {
    this.$data.t && clearTimeout(this.$data.t);
  },
  methods: {
    start: function (e) {
      e.preventDefault();
      this.$data.current = 0;
      this.$data.started = true;
      this.$data.order = Random.getShuffledArray(1,parseInt(this.$data.max) + 1);
      this.next_number();
    },
    get_rotation: function (i, v) {
      return `rotate(${(i * v * i * v + v * v) % 46 - 23}deg)`;
    },
    next_number: function () {
      this.$data.current++;
    },
    again: function () {
      if (confirm('Are you sure?')) {
        this.$data.started = false
      }
    }
  }
}
</script>

<style src="./../assets/css/game.css" scoped></style>
<style scoped>

  #loto-game {
    background: #e5e5e5 url('../assets/img/game/loto/bg.jpg');
    background-size: cover;
  }

  #balls {
    text-align: center;
    position: absolute;
    bottom: 2rem;
    left: 2rem;
    right: 2rem;
    z-index: 501;
  }

  .layout-navigation > input {
    padding-right: 0;
    width: 4rem;
    text-align: center;
  }

  .ball {
    display: inline-block;
    width: 6rem;
    height: 6rem;
    box-sizing: border-box;
    padding: 1.25rem;
    border-radius: 3rem;
    background: #808080;
    font-size: 2.5rem;
    text-align: center;
    line-height: 3.5rem;
    font-weight: bold;
    position: relative;
    margin: 1rem 0.5rem 0 0.5rem;
    overflow: hidden;
  }

  .ball[data-n="0"] {
    background: #33ffff;
  }

  .ball[data-n="1"] {
    background: #33ff33;
  }

  .ball[data-n="2"] {
    background: #ffff33;
  }

  .ball[data-n="3"] {
    background: #ff3333;
  }

  .ball[data-n="4"] {
    background: #ff33ff;
  }

  .ball[data-n="5"] {
    background: #3333ff;
  }

  .ball > span {
    display: block;
    width: 3.5rem;
    height: 3.5rem;
    border-radius: 2rem;
    background: #ffffff;
  }

  .ball:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 6rem;
    height: 6rem;
    border-radius: 2.95rem;
    box-shadow: 0 -1rem 1.75rem 0 rgba(0,0,0,0.5) inset;
  }

  .ball:last-child {
    zoom: 1.33;
    position: relative;
    margin-top: 0;
    vertical-align: top;
  }

  .layout-content {
    overflow: hidden;
  }

  /*

  #lototron-loader {
    padding: 25px;
    box-sizing: border-box;
    width: 400px;
    height: 400px;
    border-radius: 200px;
    box-shadow: 0 0 0 1rem rgba(0,0,0,0.25);
  }

  #lototron-area {
    width: 350px;
    height: 350px;
    position: relative;
  }

  #lototron-area > * {
    position: absolute;
    border-radius: 30px;
    top: 0;
    bottom: 0;
    left: 50%;
    width: 50px;
    margin-left: -25px;
    animation: spin linear 6s infinite;
  }

  #lototron-area > * > div.ball {
    box-sizing: border-box;
    padding: 10px;
    font-size: 20px;
    text-align: center;
    line-height: 30px;
    margin: -25px 0 0 0;
    top: 0;
    position: absolute;
    display: block;
    width: 50px;
    height: 50px;
    border-radius: 2rem;
    animation: jump linear 0.5s infinite, spin linear 2s infinite;
  }

  #lototron-area > * > div.ball:after {
    width: 50px;
    height: 50px;
    border-radius: 24px;
    box-shadow: 0 -8px 15px 0 rgba(0,0,0,0.5) inset;
  }

  #lototron-area > * > div.ball > span {
    width: 30px;
    height: 30px;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  @keyframes jump {
    0% { top: 100%; }
    50% { top: 0; }
    100% { top: 100%; }
  }
*/
</style>
